import styled from 'styled-components';
import { palette, font } from 'styled-theme';

const AntSelect = (ComponentName) => styled(ComponentName)`
  &:focus {
    box-shadow: none !important;
    outline: 0 none !important;
  }

  &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    height: 38px;
    border-radius: 0.6rem;
    padding: 2px 12px 0;
    font-size: 14px;
    border-color: ${palette('brColor', 0)};
  }

  &.ant-select:not(.ant-select-customize-input):hover .ant-select-selector {
    border-color: ${palette('highlighted', 0)};
  }

  &.ant-select.ant-select-focused:not(.ant-select-customize-input):not(.ant-select-disabled)
    .ant-select-selector {
    background-color: ${palette('focusedInputBgColor', 0)};
    border-color: ${palette('highlighted', 0)};

    input {
      background-color: transparent;
    }
  }

  &.ant-select-multiple .ant-select-selection-search,
  &.ant-select-multiple .ant-select-selection-item {
    margin-top: 0;
    margin-bottom: 0;
  }

  &.ant-select-multiple .ant-select-selector::after {
    margin: 0;
  }

  &.ant-select-selector .ant-select-selection-placeholder {
    font-size: 16px !important;
    font-family: ${font('primary', 0)};
  }
`;

export { AntSelect };
